<template>
  <el-dialog
    :visible.sync="visible"
    title="选择课程"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandle"
  >
    <div class="table-header mb16">
      <el-row class="in-line">
        <el-col :span="12">已选（{{ currentSelection.length }} 条）</el-col>
        <el-col :span="12"
          ><el-input
            v-model="dataForm.keyname"
            placeholder="请输入课程名称进行搜索"
            suffix-icon="el-icon-search"
            clearable
          ></el-input
        ></el-col>
      </el-row>
    </div>
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      style="width: 100%;"
      row-key="id"
      ref="table"
      @selection-change="dataListSelectionChangeHandle"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        :reserve-selection="true"
        :selectable="selectableHandle"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="课程名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="teacherName"
        label="上课老师"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="payType"
        label="收费方式"
        header-align="center"
        align="center"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="selEnd">
        确定选择
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'CourseDialog',
  mixins: [mixinViewModule],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/yxs/course/page',
        getDataListIsPage: true,
      },
      dataForm: {
        searchKey: '',
      },
      currentSelection: [],
    }
  },
  // computed: {
  //   currentSelection: {
  //     get() {
  //       return this.value
  //     },
  //     set(newVal) {
  //       this.$emit('input', newVal)
  //     },
  //   },
  // },
  mounted() {},
  watch: {},
  methods: {
    selectableHandle(row) {
      if (!this.value) {
        return true
      }
      let r = true
      this.value.forEach((item) => {
        if (item.id === row.id) {
          r = false
          return false
        }
      })
      return r
    },
    closeHandle() {
      this.currentSelection = []
      this.$refs.table.clearSelection()
    },
    dataListSelectionChangeHandle(val) {
      this.currentSelection = val
    },
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.getDataList()
      })
    },
    close() {
      this.visible = false
    },
    selEnd() {
      this.$emit('input', this.currentSelection)
      this.close()
    },
    afterTableBinding(dataList) {
      this.currentSelection = this.value
      if (!this.currentSelection) {
        return
      }
      this.currentSelection.forEach((item) => {
        let row = dataList.find((m) => m.id === item.id)
        if (!row) {
          return
        }
        this.$refs.table.toggleRowSelection(row, true)
      })
    },
  },
  components: {},
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.app-body {
  background-color: #fff;
  padding: 20px;
}
/deep/.el-form-item--default {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 120px);
}
</style>
